import { Entry, EntryAccess, StatusDefinition } from '../types';
import { makeRequest } from './makeRequest';
import { useQuery } from '@tanstack/react-query';

export type GetDataEntryResponse = {
	entry: Entry;
	entryAccess: EntryAccess;
	statuses?: StatusDefinition;
	latestEntryId: string;
};

export const useGetDataEntryQuery = ({
	entryId,
	projectId,
	setName,
	enabled
}: {
	entryId: string;
	projectId: string;
	setName?: string;
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: ['dataEntry', entryId],
		enabled,
		queryFn: () =>
			makeRequest<GetDataEntryResponse>({
				method: 'getDataEntry',
				service: 'cde',
				data: {
					datasetentryid: entryId,
					projectId,
					...(setName ? { set: { setName } } : {})
				}
			})
	});
};
